import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup as ReactCSSTransitionGroup } from 'react-transition-group';
import getReactCSSTransitionGroupClasses from '../utils/getReactCSSTransitionGroupClasses';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';

/**
* Removes any Transition specific properties from a props object that would be invalid
* if applied to a base DOM node. Useful when composing multiple components to prevent
* passing a component props that it doesn't use.
*/
export function removeNonStandardProps(props) {
  return removeKeys(props, [
    'defaultName',
    'transitionEnterTimeout',
    'transitionLeaveTimeout',
    'transitionAppearTimeout',
    'transitionAppear',
    'classes'
  ]);
}

/**
Transition - A wrapper component to add CSS Transition to the opening/closing of content.
**/
export default class Transition extends React.Component {
  static displayName = 'Transition';
  static propTypes = {
    /** The child content of the container. */
    children: PropTypes.node,
    /** Default Component Name to match Transition Classes for Localized Classes. */
    defaultName: PropTypes.string,
    /** Number Value for Transition Timeout. */
    transitionEnterTimeout: PropTypes.number,
    /** Number Value for Transition Timeout. */
    transitionLeaveTimeout: PropTypes.number,
    /** Number Value for Transition Timeout. */
    transitionAppearTimeout: PropTypes.number,
    /** Flag indicating whether to use the appear classnames. */
    transitionAppear: PropTypes.bool,
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Style applied to the transition group. */
      transitionContainer: PropTypes.object,
      /** Style for to the enter class of transition group. */
      enter: PropTypes.object,
      /** Style for to the enterActive class of transition group. */
      enterActive: PropTypes.object,
      /** Style for to the leave class of transition group. */
      leave: PropTypes.object,
      /** Style for to the leaveActive class of transition group. */
      leaveActive: PropTypes.object,
      /** Style for to the appear class of transition group. */
      appear: PropTypes.object,
      /** Style for to the appearActive class of transition group. */
      appearActive: PropTypes.object
    })
  };
  static defaultProps = {
    defaultName: 'transition',
    transitionEnterTimeout: 200,
    transitionLeaveTimeout: 200,
    transitionAppearTimeout: 200,
    transitionAppear: true,
    style: {
      transitionContainer: {},
      enter: {},
      enterActive: {},
      leave: {},
      leaveActive: {},
      appear: {},
      appearActive: {}
    }
  };

  render() {
    const containerClass = resolve(this.props, 'transitionContainer');
    const transitionGroupClassName = containerClass && containerClass.className ? containerClass.className : '';
    return (
      <ReactCSSTransitionGroup className={transitionGroupClassName}
        transitionAppear={this.props.transitionAppear}
        transitionName={getReactCSSTransitionGroupClasses(this.props, this.props.defaultName)}
        transitionEnterTimeout={this.props.transitionEnterTimeout}
        transitionAppearTimeout={this.props.transitionAppearTimeout}
        transitionLeaveTimeout={this.props.transitionLeaveTimeout} >
        {this.props.children}
      </ReactCSSTransitionGroup>
    );
  }
}
